export default "__VITE_ASSET__DfxwYzJ0__"